import { motion } from "framer-motion";
import { CreditCard, UserPlus, Users, MessageSquare, BookOpen, GraduationCap } from "lucide-react";

const features = [
  {
    icon: CreditCard,
    title: "Fee Management",
    desc: "Handle school fees, payments, and financial records with transparency.",
  },
  {
    icon: UserPlus,
    title: "Admission Management",
    desc: "Streamline the entire admissions process, from lead management to enrollment.",
  },
  {
    icon: Users,
    title: "Student Management",
    desc: "Store and manage student profiles, enrollment records, and academic information.",
  },
  {
    icon: MessageSquare,
    title: "Communication Tools",
    desc: "Send announcements and updates to students, teachers, and parents using mobile app.",
  },
  {
    icon: BookOpen,
    title: "Academics Management",
    desc: "Manage subjects, classes, exams, and grading efficiently.",
  },
  {
    icon: GraduationCap,
    title: "Teacher Management",
    desc: "Organize teacher schedules, assignments, and performance tracking.",
  },
];

const KeyFeaturesSection = () => (
  <section className="py-24 bg-white dark:bg-slate-950">
    <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
      <div className="text-center mb-16 max-w-3xl mx-auto">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase tracking-wider mb-6">
          FEATURES
        </span>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-slate-800 dark:text-slate-100 mb-6 tracking-tight">
          Key Features
        </h2>
        <p className="text-lg text-slate-500 dark:text-slate-400 font-medium leading-relaxed">
          Everything you need to run your school efficiently in one powerful platform.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((f, i) => (
          <motion.div
            key={i}
            className="flex flex-col gap-4 p-6 rounded-2xl bg-slate-50 dark:bg-slate-900/50 border border-slate-100 dark:border-slate-800 hover:shadow-lg hover:border-primary/20 transition-all group"
          >
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary/20 transition-colors">
              <f.icon className="w-6 h-6" />
            </div>
            <div>
              <h3 className="font-bold text-slate-800 dark:text-slate-200 mb-2">{f.title}</h3>
              <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">{f.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default KeyFeaturesSection;
